import { AxiosRequestConfig } from 'axios'

const joinEvent = (type: string, id: string): AxiosRequestConfig => ({
  url: `/${type}/participation/join`,
  method: 'POST',
  params: {
    id
  }
})

export { joinEvent }
